import React, { useState, useEffect } from "react";
import axios from "axios";

const Experience = () => {
  const [experiences, setExperiences] = useState([]);
  const [isContentVisible, setIsContentVisible] = useState(false);
  const [isEditing, setIsEditing] = useState(false);

  // Fetch experiences from the API
  useEffect(() => {
    axios
      .get("http://127.0.0.1:8000/dashboard/experience/") // Replace with your API URL
      .then((response) => {
        // Check if the response contains the expected structure
        if (response.data && Array.isArray(response.data.results)) {
          setExperiences(response.data.results); // Update state with the results array
          console.log("Fetched experiences:", response.data.results);
        } else {
          console.error("Unexpected API response:", response.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching experiences:", error);
      });
  }, []);
  
  
  console.log(setExperiences,"hello")

  // Update state when input changes
  const handleInputChange = (index, field, value) => {
    const updatedExperiences = [...experiences];
    updatedExperiences[index][field] = value;
    setExperiences(updatedExperiences);
  };

   // Add a new experience
   const addExperience = () => {
    setExperiences([
      ...experiences,
      {
        job_title: "",
        job_role: "",
        company: "",
        from_date: "",
        to_date: "",
      },
    ]);
  };

  const deleteExperience = (index) => {
    const experienceToDelete = experiences[index];

    if (experienceToDelete.id) {
      axios
        .delete(`http://127.0.0.1:8000/dashboard/experience/destroy/${experienceToDelete.id}/`)
        .then(() => {
          const updatedExperiences = experiences.filter((_, i) => i !== index);
          setExperiences(updatedExperiences);
        })
        .catch((error) => {
          console.error("Error deleting experience:", error);
        });
    } else {
      const updatedExperiences = experiences.filter((_, i) => i !== index);
      setExperiences(updatedExperiences);
    }
  };

  const saveExperiences = () => {
    experiences.forEach((exp) => {
      if (exp.id) {
        axios
          .put(`http://127.0.0.1:8000/dashboard/experience/update/${exp.id}/`, exp)
          .then(() => console.log("Updated experience", exp))
          .catch((error) => console.error("Error updating experience:", error));
      } else {
        axios
          .post("http://127.0.0.1:8000/dashboard/experience/save/", exp)
          .then((response) => {
            setExperiences((prevExperiences) => {
              const updatedExperiences = [...prevExperiences];
              updatedExperiences[updatedExperiences.indexOf(exp)] = response.data;
              return updatedExperiences;
            });
          })
          .catch((error) => console.error("Error creating experience:", error));
      }
    });
    setIsEditing(false);
  };

  return (
    <div className="bg-white mt-9 p-4 rounded-3xl shadow-md">
      <div className="flex justify-between items-center">
        <h1 className="font-bold text-xl m-3 ml-7 mt-4">Experience</h1>
        <button
          className="m-3 mr-7 text-blue-600 text-xl focus:outline-none"
          onClick={() => setIsContentVisible(!isContentVisible)}
        >
          {isContentVisible ? "\u25B2" : "\u25BC"} {/* Arrow Up or Down */}
        </button>
      </div>

      {isContentVisible && (
        <>
          {experiences.map((exp, index) => (
            <div
              key={index}
              className={`p-4 border-b relative mb-4 rounded-lg shadow-md ${index % 2 === 0 ? "bg-gray-50" : "bg-white"
                }`}
            >
              <div className="flex flex-col gap-4">
                <div>
                  <label className="block font-semibold">Job Title:</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={exp.job_title || ""}
                      onChange={(e) =>
                        handleInputChange(index, "job_title", e.target.value)
                      }
                      className="border rounded p-2 w-full"
                    />
                  ) : (
                    <p>{exp.job_title || "Not Provided"}</p>
                  )}
                </div>
                <div>
                  <label className="block font-semibold">Job Role:</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={exp.job_role || ""}
                      onChange={(e) =>
                        handleInputChange(index, "job_role", e.target.value)
                      }
                      className="border rounded p-2 w-full"
                    />
                  ) : (
                    <p>{exp.job_role || "Not Provided"}</p>
                  )}
                </div>
                <div>
                  <label className="block font-semibold">Company Name:</label>
                  {isEditing ? (
                    <input
                      type="text"
                      value={exp.company || ""}
                      onChange={(e) =>
                        handleInputChange(index, "company", e.target.value)
                      }
                      className="border rounded p-2 w-full"
                    />
                  ) : (
                    <p>{exp.company || "Not Provided"}</p>
                  )}
                </div>
                <div>
                  <label className="block font-semibold">Experience Duration:</label>
                  <div className="flex gap-4">
                    {isEditing ? (
                      <>
                        <input
                          type="date"
                          value={exp.from_date || ""}
                          onChange={(e) =>
                            handleInputChange(index, "from_date", e.target.value)
                          }
                          className="border rounded p-2 w-1/2"
                          placeholder="From"
                        />
                        <input
                          type="date"
                          value={exp.to_date || ""}
                          onChange={(e) =>
                            handleInputChange(index, "to_date", e.target.value)
                          }
                          className="border rounded p-2 w-1/2"
                          placeholder="To"
                        />
                      </>
                    ) : (
                      <p>
                        {exp.from_date || "Not Provided"} - {exp.to_date || "Not Provided"}
                      </p>
                    )}
                  </div>
                </div>
              </div>
              <button
                onClick={() => deleteExperience(index)}
                className="absolute bottom-1 right-1 text-red-500 hover:text-red-700"
              >
                🗑️
              </button>
            </div>
          ))}

          <div className="flex justify-between items-center p-4">
            <button
              onClick={addExperience}
              className="bg-[#0077af] text-white px-4 py-2 rounded hover:bg-blue-700"
            >
              Add Experience
            </button>
            {isEditing && (
              <button
                onClick={saveExperiences}
                className="bg-green-600 text-white px-4 py-2 rounded hover:bg-green-700"
              >
                Save Changes
              </button>
            )}
            <button
              onClick={() => setIsEditing(!isEditing)}
              className={`px-4 py-2 rounded ${isEditing
                  ? "bg-gray-500 text-white hover:bg-gray-600"
                  : "bg-[#0077af] text-white hover:bg-blue-700"
                }`}
            >
              {isEditing ? "Cancel Edit" : "Edit"}
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Experience;